module.exports = require("sequelize");


//////////////////
// WEBPACK FOOTER
// external "sequelize"
// module id = 7
// module chunks = 0